import { useMatches } from "react-router-dom";
import { useTranslation } from "react-i18next";

export interface BreadcrumbItem {
  path: string;
  label: string;
  isCurrentPage: boolean;
}

interface RouteHandle {
  breadcrumbKey?: string;
}

export function useBreadcrumbs(): BreadcrumbItem[] {
  const matches = useMatches();
  const { t } = useTranslation("nav");

  return matches
    .filter((match) => {
      const handle = match.handle as RouteHandle | undefined;
      return handle?.breadcrumbKey;
    })
    .map((match, _index, arr) => {
      const handle = match.handle as RouteHandle;
      const key = handle.breadcrumbKey!;

      // Support dynamic params in breadcrumb keys like "breadcrumbs.studentDetail"
      // that don't need interpolation — the key is just a flat lookup.
      const label = t(`breadcrumbs.${key}`);

      return {
        path: match.pathname,
        label,
        isCurrentPage: match === arr[arr.length - 1],
      };
    });
}
